module.exports = __webpack_public_path__ + "static/img/DSC_2687.ecf391a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2687.jpg
// module id = 275
// module chunks = 0